import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {reset_password_confirm, clear_user_module, RESET_PASSWORD_CONFIRM} from '../../redux/users';
import {useParams, useHistory} from 'react-router-dom';
import InputPassword from '../../components/input_password';
import Button from '../../components/button';
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from "../../components/loading-spinner";

const ResetPassword = () => {
    let history = useHistory();
    let dispatch = useDispatch();
    const _reset_password_confirm = useSelector((state) => state.users_module._reset_password_confirm);
    const {uid, token} = useParams();
    const [form, setForm] = useState({
        new_password1: '',
        new_password2: '',
        uid: uid,
        token: token,
    });
    const [isLoading, setIsLoading] = useState(false);
    /* const [msj, setMsj] = useState({
        type: '',
        text: '',
        show: false,
    }); */

    useEffect(() => {
        if (_reset_password_confirm.status === 200) {
            dispatch(clear_user_module(RESET_PASSWORD_CONFIRM));
            toast.success('Se ha cambiado la contraseña correctamente', {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            //esperar 5 segundos
            setTimeout(() => {
                history.push('/');
            }, 5000);
        } else if (_reset_password_confirm.status !== 0) {
            toast.error(_reset_password_confirm.message, {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_user_module(RESET_PASSWORD_CONFIRM));
            setIsLoading(false);
        }
    }, [_reset_password_confirm, dispatch, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        //validate data
        if (form.new_password1 === '') {
            toast.error("Debe ingresar la contraseña", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        } else {
            if (form.new_password1.length < 8 || form.new_password1.length > 20) {
                toast.error("La contraseña debe tener un mínimo de 8 caracteres y un máximo de 20 caracteres.", {position: toast.POSITION.TOP_RIGHT});
                setIsLoading(false);
                return;
            } else {
                const mayymin = /(?:[A-Z])/.test(form.new_password1) && /(?:[a-z])/.test(form.new_password1);
                const numeros = /(?:\d)/.test(form.new_password1);
                const especial = /(?=.*?[#?!@$ %^&*-_])/.test(form.new_password1);
                const valida = mayymin && numeros && especial;
                if (!valida) {
                    toast.error("La contraseña debe incluir al menos un número, una letra mayúscula y un carácter especial.", {position: toast.POSITION.TOP_RIGHT});
                    setIsLoading(false);
                    return;
                }
            }
        }
        if (form.new_password2 === '') {
            toast.error("Debe ingresar la contraseña de validación", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        } 
        if (form.new_password1 !== form.new_password2) {
            toast.error("Las contraseñas no coinciden", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        dispatch(reset_password_confirm(form));
    }

    return (
        <div className="app-content content">
            <div><ToastContainer/></div>
            {isLoading && <LoadingSpinner/>}
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">
                    {/* reset password start */}
                    <section className="row flexbox-container">
                        <div className="col-xl-7 col-10">
                            <div className="card bg-authentication mb-0">
                                <div className="row m-0">
                                    {/* left section-login */}
                                    <div className="col-md-6 col-12 px-0">
                                        <div
                                            className="card disable-rounded-right d-flex justify-content-center mb-0 p-2 h-100">
                                            <div className="card-header pb-1">
                                                <div className="card-title">
                                                    <h4 className="text-center mb-2">Recuperar contraseña</h4>
                                                </div>
                                            </div>
                                            <div className="card-content">
                                                <div className="card-body">
                                                    <form className="mb-2" onSubmit={handleSubmit}>
                                                        {/* <Alert
                                                            message=""
                                                            type="bg-rgba-info"
                                                            show={true}
                                                        /> */}
                                                        <InputPassword
                                                            type="password"
                                                            name="new_password1"
                                                            id="new_password1"
                                                            id_div1="show_hide_password"
                                                            id_div2="password"
                                                            label="Nueva contraseña"
                                                            placeholder="Nueva contraseña"
                                                            value={form.new_password1}
                                                            onChange={handleChange}
                                                        />
                                                        <div className='mb-1 p-1'
                                                             style={{background: 'rgb(137 225 221 / 65%)'}}>
                                                            <small>* La contraseña debe tener un mínimo de 8 caracteres
                                                                y un máximo de 20 caracteres.</small><br/>
                                                            <small>* La contraseña debe incluir al menos un número, una
                                                                letra mayúscula y un carácter especial.</small><br/>
                                                            <small>* La contraseña no puede estar relacionada con el
                                                                nombre de la joyeria, código o usuario.</small>
                                                        </div>
                                                        <InputPassword
                                                            type="password"
                                                            name="new_password2"
                                                            id="new_password2"
                                                            id_div1="show_hide_password1"
                                                            id_div2="password1"
                                                            label="Confirmar contraseña"
                                                            placeholder="Confirmar contraseña"
                                                            value={form.new_password2}
                                                            onChange={handleChange}
                                                        />

                                                        <Button
                                                            text="Cambiar contraseña"
                                                            type="submit"
                                                            classes="btn-primary  btn-block"
                                                            disabled={isLoading}
                                                        />
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* right section image */}
                                    <div className="col-md-6 d-md-block d-none text-center align-self-center p-3">
                                        <img className="img-fluid"
                                             src={window.location.origin + "/base/app-assets/images/pages/reset-password.png"}
                                             alt="branding logo"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* reset password ends */}
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;